/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { MyButton } from "../../component/Component";
import { useStaticContext } from "../../../../context/static/StaticContext";
import { pushOneService } from "../../../../middlewares/sysNavigation/SysNavigation";

const editRoute = "/service/edit";

const Overview = () => {
  const [serviceList, setServiceList] = useState([]);
  const { service, fetchService } = useStaticContext();

  useEffect(() => {
    if (!service) fetchService();
    else setServiceList(service);
  }, [service]);

  const hasData = Array.isArray(serviceList) && serviceList.length > 0;

  return (
    // Keep vertical scrolling exactly like original to avoid overflow issues
    <div className="p-3 lg:p-4 h-full overflow-y-auto rounded-b-xl bg-gray-50">
      <div className="mx-auto w-full max-w-7xl">
        {/* Header (non-sticky to avoid scroll bugs) */}
        <div className="mb-4 rounded-xl border border-gray-200 bg-white p-4 shadow-sm">
          <div className="flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between">
            <div className="min-w-0">
              <h1 className="text-sm font-semibold tracking-tight text-gray-900 lg:text-base">
                Services Overview
              </h1>
              <p className="mt-0.5 text-[11px] text-gray-500">
                Titles & descriptions shown under Services
              </p>
            </div>
            <span className="inline-flex items-center gap-2 rounded-full bg-gray-50 px-3 py-1 text-[11px] font-medium ring-1 ring-gray-200">
              <span className="h-1.5 w-1.5 rounded-full bg-emerald-500" />
              Items: {hasData ? serviceList.length : 0}
            </span>
          </div>
        </div>

        {/* Table card */}
        <div className="rounded-xl border border-gray-200 bg-white shadow-sm">
          <div className="w-full overflow-x-auto">
            <table className="min-w-full table-auto text-left text-sm">
              <thead>
                <tr className="bg-gray-50">
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Title
                  </th>
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 font-semibold text-gray-700">
                    Description
                  </th>
                  <th className="w-1/3 border-b border-gray-200 px-4 py-3 text-center font-semibold text-gray-700">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {service ? (
                  hasData ? (
                    serviceList.map((srvc) => (
                      <tr
                        key={srvc?.service_id}
                        className="transition-colors hover:bg-gray-50"
                      >
                        <td className="px-4 py-3 align-top text-gray-900 break-words whitespace-pre-line">
                          {srvc?.title}
                        </td>
                        <td className="px-4 py-3 align-top text-gray-700">
                          <div className="max-w-[60ch] whitespace-pre-line break-words">
                            {srvc?.description}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <ActionButton props={srvc} />
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td className="px-4 py-8 text-center text-sm text-gray-500" colSpan={3}>
                        No services yet.
                      </td>
                    </tr>
                  )
                ) : (
                  // Loading skeleton (keeps layout stable)
                  Array.from({ length: 3 }).map((_, i) => (
                    <tr key={i} className="animate-pulse">
                      <td className="px-4 py-3">
                        <div className="h-4 w-40 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="h-4 w-64 rounded bg-gray-200" />
                      </td>
                      <td className="px-4 py-3">
                        <div className="mx-auto h-9 w-20 rounded-lg bg-gray-200" />
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Helper text */}
        <p className="mt-3 text-[11px] text-gray-500">
          Aim for short, benefit-focused descriptions (~120–160 characters).
        </p>
      </div>
    </div>
  );
};

/**
 *  @author Ntavigwa Bashombe
 * @param {*} props
 * @returns
 */
const ActionButton = ({ props }) => {
  return (
    <div className="flex items-center justify-center">
      <Link to={editRoute}>
        <MyButton
          title="Edit"
          className="rounded-lg bg-blue-600 px-3 py-2 text-xs font-semibold shadow-sm transition hover:bg-blue-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-500"
          onClick={() => pushOneService(props)}
        />
      </Link>
    </div>
  );
};

export default Overview;
